var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18568 8.49999C6.10703 8.50047 6.02907 8.48471 5.95626 8.45362C5.88345 8.42253 5.81722 8.37673 5.76138 8.31883L2.17575 4.57076C2.06322 4.45313 2 4.29359 2 4.12724C2 3.96088 2.06322 3.80134 2.17575 3.68371C2.28828 3.56608 2.44091 3.5 2.60005 3.5C2.75919 3.5 2.91182 3.56608 3.02435 3.68371L6.18568 6.99451L9.34701 3.68996C9.46133 3.58762 9.60839 3.53414 9.75879 3.54022C9.9092 3.54629 10.0519 3.61146 10.1583 3.72272C10.2647 3.83397 10.3271 3.9831 10.3329 4.14032C10.3387 4.29754 10.2875 4.45126 10.1896 4.57076L6.604 8.31883C6.49269 8.43424 6.34246 8.4993 6.18568 8.49999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.f5a18fb3ec181c6f3162c2ad9f8e1fe3.svg";
export { ForwardRef as ReactComponent };